import { render, staticRenderFns } from "./RegisterAccountPage.vue?vue&type=template&id=62f41cfc&scoped=true&"
import script from "./RegisterAccountPage.vue?vue&type=script&lang=js&"
export * from "./RegisterAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAccountPage.vue?vue&type=style&index=0&id=62f41cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f41cfc",
  null
  
)

export default component.exports